import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Table, Row, Col, Button } from 'antd';
import { Chart } from "react-google-charts";
var moment = require('moment-timezone');

const CustomDashboard = () => {

    useEffect(() => {
        document.title = "DoorTally Dashboard"
    }, []);

    let { account_id } = useParams();


    const [loading, setLoading] = useState(false);
    const [currentTemp, setCurrentTemp] = useState(0);

    const getWeather = () => {

        axios({
            "method": "GET",
            "url": "https://api.openweathermap.org/data/2.5/weather?q=antwerp,be&appid=c2c8c7a501e65911b58ac8bf560bfcdf",
        })
            .then((response) => {
                const ktemp = response.data.main.temp;
                const ctemp = (ktemp - 273.1).toFixed();
                setCurrentTemp(ctemp)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const [currentCount, setCurrentCount] = useState({
        current_occupancy: 0,
        last_five_entrance: 0,
        last_five_exit: 0,
        total_visits: 0,
    });

    const getCurrentCount = async () => {

        axios({
            "method": "GET",
            "url": `https://app.doortally.com/api/v1/live/custom/count/${account_id}`,
        })
            .then((response) => {
                setCurrentCount(response.data.Data);
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const [entrances, setEntrances] = useState([]);
    const [exits, setExits] = useState([]);

    const getUserCount = async () => {

        axios({
            "method": "GET",
            "url": `https://app.doortally.com/api/v1/live/custom/position/${account_id}`,
        })
            .then((response) => {

                var data = response.data.Data;

                const in_array = data.sort((a, b) => parseFloat(b.entrances) - parseFloat(a.entrances)).slice(0, 5);
                const out_array = data.sort((a, b) => parseFloat(b.exits) - parseFloat(a.exits)).slice(0, 5);

                setEntrances(in_array)
                setExits(out_array)

            })
            .catch((error) => {
                console.log(error)
            })
    }


    const [activityData, setActivityData] = useState([new Date(), 0, 0]);

    const getActivityChart = async () => {

        axios({
            "method": "GET",
            "url": `https://app.doortally.com/api/v1/live/custom/table/${account_id}`,
        })
            .then((response) => {

                var data = response.data.Data;
                const activity_array = [];

                data.entrances.forEach((x, i) => {
                    //                    activity_array.push([new Date(x.activity_datetime), Number(x.count), 0])
                    //activity_array.push([new Date(x.activity_datetime), Number(x.count), 0])

                    activity_array.push([new Date(moment(x.activity_datetime).tz("Europe/Brussels").format()), Number(x.count), 0])

                })
                data.exits.forEach((x, i) => {
                    //                    activity_array.push([new Date(x.activity_datetime), 0, Number(x.count)])
                    activity_array.push([new Date(moment(x.activity_datetime).tz("Europe/Brussels").format()), 0, Number(x.count)])

                })

                setActivityData(activity_array)
                setLoading(false)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const loadData = async () => {

        console.log('laoding data')
        getWeather();
        getCurrentCount();

        getUserCount();
        getActivityChart();


    }

    const refreshData = async () => {
        window.location.reload(false);
    }

    const entrance_columns = [
        {
            title: 'Position',
            dataIndex: 'position',
            key: 'position',
        },
        {
            title: 'Entrances',
            dataIndex: 'entrances',
            key: 'entrances',
        },
    ];

    const exit_columns = [
        {
            title: 'Position',
            dataIndex: 'position',
            key: 'position',
        },
        {
            title: 'Exits',
            dataIndex: 'exits',
            key: 'exits',
        },
    ];

    useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <>
            <div className="container">

                <Row gutter={8} style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                    <Col span={16}>
                        <p style={{ fontSize: '20px' }}>Antwerpen Meir</p>
                    </Col>
                    <Col span={8}>
                        <Button type="primary" onClick={refreshData}>Refresh</Button>
                    </Col>

                </Row>

                {loading ?
                    <><p style={{ fontSize: '30px', color: '#1890ff' }}>LOADING...</p></>
                    :
                    <>


                        <Row gutter={8} style={{ paddingTop: '20px' }}>
                            <Col span={8}>
                                <p style={{ fontSize: '20px' }}>Current Count</p>
                                <p style={{ fontSize: '30px', color: '#1890ff' }}>{currentCount.current_occupancy}</p>

                            </Col>
                            <Col span={8}>
                                <p style={{ fontSize: '20px' }}>Current Weather</p>
                                <p style={{ fontSize: '30px', color: '#1890ff' }}>{currentTemp}°C</p>
                            </Col>
                            <Col span={8}>
                                <p style={{ fontSize: '20px' }}>Total Visits</p>
                                <p style={{ fontSize: '30px', color: '#1890ff' }}>{currentCount.total_visits}</p>
                            </Col>
                        </Row>


                        <Row gutter={8}  >
                            <Col span={12}>
                                <p style={{ fontSize: '20px' }}>Last 5' In</p>
                                <p style={{ fontSize: '30px', color: '#1890ff' }}>{currentCount.last_five_entrance}</p>
                            </Col>
                            <Col span={12}>
                                <p style={{ fontSize: '20px' }}>Last 5' Out</p>
                                <p style={{ fontSize: '30px', color: '#1890ff' }}>{currentCount.last_five_exit}</p>
                            </Col>
                        </Row>


                        <Row gutter={8} style={{ paddingBottom: '20px' }}>
                            <Col span={24}>
                                <p style={{ fontSize: '20px' }}>Entrances/Exits</p>

                                <Chart
                                    width={'100%'}
                                    chartType="LineChart"
                                    loader={<div>Loading Chart</div>}
                                    data={[
                                        ['Date', 'In', 'Out'],
                                        ...activityData
                                    ]}

                                    options={{
                                        intervals: { style: 'sticks' },
                                        legend: 'true',
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row gutter={8}  >
                            <Col span={12} xs={24} sm={24} md={12} lg={12}>
                                <p style={{ fontSize: '20px' }}>Top 5 In</p>
                                <Table
                                    key="id"
                                    rowkey="id"
                                    pagination={false}
                                    showHeader={false}
                                    dataSource={entrances}
                                    columns={entrance_columns}
                                />
                            </Col>
                            <Col span={12} xs={24} sm={24} md={12} lg={12}>
                                <p style={{ fontSize: '20px' }}>Top 5 Out</p>
                                <Table
                                    rowkey="id"
                                    pagination={false}
                                    showHeader={false}
                                    dataSource={exits}
                                    columns={exit_columns}
                                />
                            </Col>
                        </Row>

                    </>
                }
            </div>
        </>
    );
};

export default CustomDashboard;